import { render, staticRenderFns } from "./Couriers.vue?vue&type=template&id=cc5825a4&scoped=true"
import script from "./Couriers.vue?vue&type=script&lang=js"
export * from "./Couriers.vue?vue&type=script&lang=js"
import style1 from "./Couriers.vue?vue&type=style&index=1&id=cc5825a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5825a4",
  null
  
)

export default component.exports